var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Uspesna akcija!")]),_c('div',{staticClass:"footer"},[_c('button',{staticClass:"btn btn-danger btn--mod",attrs:{"type":"submit"},on:{"click":_vm.closeModal}},[_vm._v("\n      OK\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }